import { InjectionToken, Provider } from '@angular/core';
import { RenderableComponentType } from '@y42/angular/component-renderer';
import { Asset } from '../../models/asset.model';

export const ASSET_SIDEBAR_ACTIVE_ASSET = new InjectionToken<Asset>('Asset Sidebar Active Asset');

export const IS_ASSET_SIDEBAR_ROUTED = new InjectionToken<boolean>('Is Asset-Sidebar Routed');

export const ASSET_SIDEBAR_LINEAGE_BUTTON = new InjectionToken<RenderableComponentType>(
  'Asset Sidebar Lineage Button Provided Component',
);

export function provideAssetSidebarOverviewLineageButton(component: RenderableComponentType): Provider {
  return {
    provide: ASSET_SIDEBAR_LINEAGE_BUTTON,
    useValue: component,
  };
}

export const ASSET_SIDEBAR_LINEAGE_DEPENDENT_ASSETS = new InjectionToken<RenderableComponentType>(
  'Asset Sidebar Lineage Dependent Assets',
);

export function provideAssetSidebarLineageDependentAssets(component: RenderableComponentType): Provider {
  return {
    provide: ASSET_SIDEBAR_LINEAGE_DEPENDENT_ASSETS,
    useValue: component,
  };
}
